module.exports = __webpack_public_path__ + "static/media/dem_the_lan.a3e0b699.png";